import { gql } from '@apollo/client';

export const UPLOAD_TRAINER_WORK_SITUATION_SIGNATURE = gql`
    mutation UploadTrainerWorkSituationSignature(
        $id: ID!
        $file: Upload!
    ) {
        uploadTrainerWorkSituationSignature(
            id: $id,
            file: $file,
        ) {
            id
        }
    }
`
